import * as z from "zod";

const propertyTypes = ["apartment", "house", "office", "commercial", "land"] as const;
const propertyStatuses = ["available", "occupied", "sold", "pending", "maintenance"] as const;

export const propertyFormSchema = z.object({
  name: z.string().min(1, "properties.form.validation.nameRequired"),
  description: z.string().optional(),
  type: z.enum(propertyTypes, {
    required_error: "properties.form.validation.typeRequired",
  }),
  status: z.enum(propertyStatuses, {
    required_error: "properties.form.validation.statusRequired",
  }),
  price: z.number({
    required_error: "properties.form.validation.priceRequired",
    invalid_type_error: "properties.form.validation.priceRequired",
  }).min(0, "properties.form.validation.priceMin"),
  currency: z.literal("USD"),
  address: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  stateAbbreviation: z.string().optional(),
  country: z.string().optional(),
  countryAbbreviation: z.string().optional(),
  postalCode: z.string().optional(),
  area: z.number().min(0).optional(),
  rooms: z.number().min(0).optional(),
  bathrooms: z.number().min(0).optional(),
  floor: z.number().min(0).optional(),
  totalFloors: z.number().min(0).optional(),
  yearBuilt: z.number().min(1800).optional(),
  features: z.array(z.string()).optional(),
  geoLocation: z.any().optional(),
});
